import { styled } from '@mui/material/styles'
import Pagination from '@mui/material/Pagination'

const getStyles = (theme) => (
  {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '30px 0'
    }
  }
)
const PREFIX = 'PaginatorStyle'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const PaginatorStyle = styled(Pagination)(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  PaginatorStyle
}
